<rt-dropdown-header>
  <rt-icon-button
    *ngIf="hasBackAction"
    prefix
    (click)="goBack.emit($event)"
    variant="plain"
    iconName="keyboard-backspace"
    shape="square"
    size="small"
  >
  </rt-icon-button>
  <span>
    {{ label }}
  </span>
  <rt-icon-button
    *ngIf="hasSettings"
    suffix
    (click)="goToSettings.emit($event)"
    variant="plain"
    iconName="settings"
    shape="square"
    size="small"
  >
  </rt-icon-button>
</rt-dropdown-header>
<div>
  <rt-form-field *ngIf="hasSearch" class="context-default" padding-tb-small-x padding-lr-small>
    <rt-input
      [value]="searchQuery"
      [autoFocus]="true"
      [hasClearButton]="true"
      (focus)="onFocusChanges(true)"
      (blur)="onFocusChanges(false)"
      (valueChange)="searchQueryChange.emit($event)"
      variant="rounded"
      [placeholder]="searchPlaceholder"
    >
      <rt-icon prefix name="search"></rt-icon>
    </rt-input>
  </rt-form-field>
</div>
